<!--suppress ALL -->
<div class="m--4">
  <ng-container *ngFor="let palette of palettes">
    <div class="mb--2">
      <mat-tab-group
        mat-stretch-tabs="false"
        mat-align-tabs="start"
        [color]="palette"
      >
        <mat-tab label="First"></mat-tab>
        <mat-tab label="Second"></mat-tab>
        <mat-tab label="Third"></mat-tab>
      </mat-tab-group>
    </div>
  </ng-container>

  <ng-container *ngFor="let palette of palettes">
    <h3 class="text-center">{{ palette | titlecase }}</h3>
    <div class="flex">
      <div
        exp-container
        *ngFor="let state of states"
        [palette]="palette"
        [paletteState]="state"
        padding="3,2 4, 5"
        pl="10"
        margin="2"
        borderRadius="default"
        width="20"
      >
        {{ state | titlecase}}
      </div>
    </div>
  </ng-container>

  <div style="background-color: white">
    <div *ngFor="let palette of palettes">
      <h3 class="text-center">{{ palette | titlecase }}</h3>

      <button mat-raised-button [color]="palette" class="mr--2">Enabled</button>

      <button mat-raised-button [color]="palette" class="mr--2" disabled>
        Disabled
      </button>
    </div>
  </div>
</div>
